/** Resolutor compartido de errores devueltos por la API FastAPI / red. */

const DEFAULT_MESSAGES = {
  RATE_LIMITED: "Demasiados intentos. Inténtalo en una hora.",
  TURNSTILE_FAILED: "Verificación de seguridad fallida. Recarga la página e inténtalo de nuevo.",
  EMAIL_ALREADY_HAS_ACTIVE_SUBSCRIPTION: "Ya tienes una suscripción activa con este correo.",
  INVALID_PLAN: "El plan seleccionado no es válido. Vuelve a la página de precios.",
  STRIPE_ERROR: "Error con Stripe. Inténtalo de nuevo.",
  VALIDATION_ERROR: "Revisa que todos los campos estén completos y sean válidos.",
  INVALID_INPUT: "Revisa que todos los campos estén completos y sean válidos.",
};

const NETWORK_ERROR = "No se pudo conectar. Verifica tu conexión e inténtalo de nuevo.";

/**
 * @param {unknown} err — error de axios (o equivalente)
 * @param {Record<string, string>} [overrides] — mensajes específicos por code
 * @returns {string} mensaje listo para mostrar al usuario
 */
export function resolveApiError(err, overrides = {}) {
  const response = err && typeof err === "object" ? err.response : undefined;
  const status = response?.status;
  const code = response?.data?.code;
  const messages = { ...DEFAULT_MESSAGES, ...overrides };

  if (code && messages[code]) return messages[code];
  if (status === 422 && messages.VALIDATION_ERROR) return messages.VALIDATION_ERROR;
  if (!response) return NETWORK_ERROR;

  return `Error inesperado (${status ?? "desconocido"}). Inténtalo de nuevo.`;
}
